import type { BlockQualifyingConditions } from 'types/block-qualifying-conditions';

import React from 'react';
import Image from 'next/image';
import { Button, Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import Figure from './figure';
import WysiwygContent from './wysiwyg-content';

const QualifyingConditions: React.FC<BlockQualifyingConditions> = ({
  sectionId,
  instanceId,
  title,
  intro,
  button,
  conditionsList,
}) => {
  return (
    <>
      <section
        id={sectionId}
        itemID={`QualifyingConditions-${instanceId}`}
        className="bg-[#F2F5F8] mt-12 md:mt-16"
      >
        <Wrap>
          {title || intro ? (
            <div className="grid gap-y-6 justify-items-center">
              {title && (
                <HeadingBody
                  level="2"
                  tagName="h2"
                  title={title}
                  className="font-semibold text-center"
                />
              )}
              {intro && (
                <Paragraph
                  dangerouslySetInnerHTML={{ __html: intro }}
                  size="large"
                  className="text-center lg:max-w-5xl"
                />
              )}
            </div>
          ) : null}
          {conditionsList ? (
            <WysiwygContent
              content={conditionsList}
              className="w-full !text-lg"
            />
          ) : null}
          {button ? (
            <Button
              href={button.url}
              label={button.title}
              variant="dark"
              filled={false}
              rounded={true}
              className="w-full md:w-fit h-fit justify-self-center"
            />
          ) : null}
        </Wrap>
      </section>
      <div className="relative grid lg:grid-cols-2 overflow-hidden mb-12 md:mb-16">
        <div className="relative">
          <Image
            src="/qualifying-conditions-block-img.png"
            alt=""
            width={800}
            height={600}
            className="w-full h-full object-cover"
          />
          <div className="hidden lg:block absolute inset-y-0 right-0 w-1/3 bg-gradient-to-r from-transparent to-white" />
        </div>
        <div className="flex flex-col gap-y-4 justify-center px-8 py-10 lg:py-0 lg:px-20">
          <HeadingBody
            level="3"
            tagName="h3"
            title={`Convenient, <span class="text-purple-500">Quality Care</span></br> When You Need It Most`}
            className="font-semibold text-center"
          />
          <Paragraph size="large" className="text-center">
            With Leafwell, you'll be matched up with a{' '}
            <span className="text-dark-green">highly knowledgeable</span>,{' '}
            <span className="text-dark-green">empathetic</span>,{' '}
            <span className="text-dark-green">licensed</span> medical marijuana
            doctor.
          </Paragraph>
        </div>
      </div>
    </>
  );
};

export default QualifyingConditions;
